// Opções fixas do dropdown de CRM do onboarding, exibidas após a lista
// dinâmica vinda de GET /crms. Não são CRMs reais, por isso não vêm do backend.
export const CRM_OPTION_OTHER = { text: 'Outros', value: 'Outros' }
export const CRM_OPTION_NONE = { text: 'Não uso nenhum', value: 'None' }



// WEBPACK FOOTER //
// ./src/services/crmList.js